import { Component, OnInit, OnDestroy, Renderer2, inject, input } from '@angular/core';
import { NavigationService } from '../../../shared/services/navigation.service';
import { Subscription } from 'rxjs';
import { ThemeService, ITheme } from '../../../shared/services/theme.service';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { LayoutService } from '../../services/layout.service';
import { Router, RouterLinkActive, RouterLink } from '@angular/router';
import { LogoutService } from 'app/shared/services/logout.service';
import { MatRipple } from '@angular/material/core';
import { MatIcon } from '@angular/material/icon';
import { MatSelect } from '@angular/material/select';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/autocomplete';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatGridList, MatGridTile } from '@angular/material/grid-list';

@Component({
    selector: 'app-header-top',
    templateUrl: './header-top.component.html',
    styleUrls: ['./header-top.component.scss'],
    imports: [RouterLinkActive, MatRipple, RouterLink, MatIcon, MatSelect, ReactiveFormsModule, FormsModule, MatOption, MatIconButton, MatTooltip, MatMenuTrigger, MatMenu, MatGridList, MatGridTile, MatMenuItem, TranslatePipe]
})
export class HeaderTopComponent implements OnInit, OnDestroy {
  private layout = inject(LayoutService);
  private navService = inject(NavigationService);
  themeService = inject(ThemeService);
  translate = inject(TranslateService);
  private renderer = inject(Renderer2);
  private authService = inject(LogoutService);
  private router = inject(Router);

  layoutConf: any;
  menuItems: any;
  menuItemSub: Subscription;
  themes: ITheme[] = [];
  currentLang = 'en';
  availableLangs = [
    {
      name: 'English',
      code: 'en',
    },
    {
      name: 'Spanish',
      code: 'es',
    },
  ];
  readonly notificPanel = input(undefined);
  private readonly openDropdowns = new Set<string>();

  ngOnInit() {
    this.layoutConf = this.layout.layoutConf;
    this.themes = this.themeService.egretThemes;
    this.menuItemSub = this.navService.menuItems$.subscribe((res) => {
      res = res.filter(
        (item) => item.type !== 'icon' && item.type !== 'separator'
      );
      const limit = 4;
      const mainItems: any[] = res.slice(0, limit);
      if (res.length <= limit) {
        return (this.menuItems = mainItems);
      }
      const subItems: any[] = res.slice(limit, res.length - 1);
      mainItems.push({
        name: 'More',
        type: 'dropDown',
        tooltip: 'More',
        icon: 'more_horiz',
        sub: subItems,
      });
      this.menuItems = mainItems;
    });
  }
  ngOnDestroy() {
    this.menuItemSub.unsubscribe();
  }
  toggleDropdown(id: string) {
    if (this.openDropdowns.has(id)) {
      this.openDropdowns.delete(id);
    } else {
      this.openDropdowns.add(id);
    }
  }

  isDropdownOpen(id: string): boolean {
    return this.openDropdowns.has(id);
  }

  setLang() {
    this.translate.use(this.currentLang);
  }
  changeTheme(theme: ITheme) {
    this.layout.publishLayoutChange({ matTheme: theme.name });
  }
  toggleNotific() {
    this.notificPanel().toggle();
  }
  toggleSidenav() {
    if (this.layoutConf.sidebarStyle === 'closed') {
      return this.layout.publishLayoutChange({
        sidebarStyle: 'full',
      });
    }
    this.layout.publishLayoutChange({
      sidebarStyle: 'closed',
    });
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/sessions/signin']);
  }
}
